var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestDesktopDropdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 8,
  viewBox: "0 0 12 8",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6 8 .33 2.022a1.227 1.227 0 0 1 0-1.674 1.08 1.08 0 0 1 1.59 0L6 4.646 10.08.348a1.08 1.08 0 0 1 1.59 0c.44.464.44 1.216 0 1.674z"
})));
export default SvgPinterestDesktopDropdown;